import React, { useEffect,useState } from 'react';
import TemplateNames from './TemplateNames';
import TemplateContent from './TemplateContent';
import TemplateButton from './TemplateButton';
import Preview from './Preview';

const MarketingDefault = ({template,setTemplate,selectedCategory,selectedSubCat,showPreview,setShowPreview,setMediaId}) => {

  const [mediaPreview,setMediaPreview]=useState(null)
  const [varType,setVarType]=useState("Number")

  return (
     <div className="flex h-screen bg-gradient-to-br from-purple-50 to-gray-90">
      {/* Left Side */}
      <div className="flex-1 flex flex-col p-5 overflow-y-auto">
        
        <TemplateNames 
          template={template}
          setTemplate={setTemplate}
          selectedSubCat={selectedSubCat}
          selectedCategory={selectedCategory}
        />

        <TemplateContent
          setTemplate={setTemplate}
          setMediaPreview={setMediaPreview}
          template={template}
          setVarType={setVarType}
          setShowPreview={setShowPreview}
          mediaPreview={mediaPreview}
          setMediaId={setMediaId}
        />

        <TemplateButton
         template={template}
          setTemplate={setTemplate} />
      </div>

      {/* Right Side (Preview) */}
      <div className="w-1/3 border-l  border-gray-200 bg-gradient-to-br from-purple-50 to-gray-90 p-5 flex-shrink-0">
        <Preview 
          template={template}
          mediaPreview={mediaPreview}
          varType={varType}
          showPreview={showPreview}
        
        />
      </div>
    </div>
          
  );
}

export default MarketingDefault;
